import { ChevronsRight as ChevronRight } from "styled-icons/feather/ChevronsRight"
import { Whatsapp } from "styled-icons/icomoon/Whatsapp"
import { Send } from "@styled-icons/boxicons-regular/Send"
import { News } from "@styled-icons/fluentui-system-regular/News"
import { CardList } from "@styled-icons/bootstrap/CardList"

const Icons = {
  ChevronRight,
  Whatsapp,
  Send,
  News,
  CardList,
}

export default Icons
